import { Loader } from '@client/components/common/Loader';
import type { WrapperProps } from '../interfaces';

export const DumbWrapper = <C extends React.ElementType>({
  adminOnly, requiresLogin, component, path,
  history, location, staticContext, match,
  requiresProfile,
  ...restProps
}: WrapperProps<C>) => {
  const { params = {} } = match || {};

  if (component) {
    const Component = component as any;

    return (
      <Component
        pathname={location.pathname}
        {...params}
        {...restProps}
      />
    );
  }

  return (
    <Loader
      pathname={location.pathname}
      {...params}
      {...restProps}
    />
  );
};
